import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { BOOK } from "@/lib/site";

export default function ReviewCTA() {
  return (
    <section id="reviews" className="relative z-10 py-20 md:py-28" data-testid="review-cta">
      <div className="mx-auto max-w-3xl px-6 text-center md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="rounded-3xl border border-gold/25 bg-gold/[0.06] p-8 md:p-12"
        >
          <div className="flex justify-center gap-1 text-gold">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-gold" />
            ))}
          </div>
          <h2 className="mt-5 font-display text-3xl font-bold leading-tight text-cream md:text-4xl">
            Loved the book? Share your heart.
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-body text-lg leading-relaxed text-slate-300">
            Your review helps other families discover <em className="not-italic text-cream">Hannah's Heart Awakens</em> —
            it only takes a minute and means the world.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a
              href={BOOK.amazonReview}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="review-amazon"
              className="inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 font-medium text-twilight transition-[background-color,box-shadow] duration-300 hover:bg-gold-light hover:shadow-[0_0_25px_rgba(251,191,36,0.55)]"
            >
              <Star className="h-4 w-4" /> Review on Amazon
            </a>
            <a
              href={BOOK.goodreads}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="review-goodreads"
              className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-gold/10 px-7 py-3.5 font-medium text-gold transition-[background-color] duration-300 hover:bg-gold hover:text-twilight"
            >
              <Star className="h-4 w-4" /> Review on Goodreads
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
